<template>
  <layout>
    <div slot="content">
      <i-card title="广告管理">
        <div slot="content">
          <el-table
            :border="true"
            :highlight-current-row="true"
            :data="adsList"
            style="width: 100%"
          >
            <el-table-column
              label="图片"
              width="80"
            >
              <template slot-scope="scope">
                <img :src="scope.row.cover_pic" width="50" height="50">
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="广告名称"
            ></el-table-column>
            <el-table-column
              label="开始投放"
              width="160"
              prop="start_time"
            >
            </el-table-column>
            <el-table-column
              label="结束投放"
              width="160"
              prop="end_time"
            >
            </el-table-column>
            <el-table-column
              label="展示状态"
            >
              <div slot-scope="scope">
                <el-tag v-if="scope.row.on_show == 1" size="mini" type="success">正常投放</el-tag>
                <el-tag v-else type="danger" size="mini">停止投放</el-tag>
              </div>
            </el-table-column>
            <el-table-column
              prop="position_name"
              label="投放位置"
            ></el-table-column>
            <el-table-column
              label="操作"
            >
              <div slot-scope="scope">
                <router-link :to="{name:'settings.edit_ads',query:{ads_id:scope.row.id}}">
                  <el-button size="mini" type="primary">编辑</el-button>
                </router-link>
                <el-button size="mini" type="primary">删除</el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
          <router-link :to="{name:'settings.add_ads'}">
            <el-button type="success" size="medium" icon="el-icon-plus">添加广告</el-button>
          </router-link>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
  export default {
    name: "ads",
    data() {
      return {
        adsList: []
      }
    },
    methods: {
      getAdsList: function () {
        this.$http.request('adsList').then((res) => {
          this.adsList = res.data;
        });
      }
    },
    created: function () {
      this.getAdsList();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/ads.vue